/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { BUILD_ENV } from '../../../constants/env';
const { NODE_ENV } = process.env;

/**
 * Checks if in development environment.
 *
 * @returns {boolean} True if development environment; otherwise false.
 */
export const isDevEnv = () => {
  let ret;

  if (!NODE_ENV) {
    ret = false;
  } else {
    ret = process.env.NODE_ENV === 'development' || BUILD_ENV === 'development';
  }

  return ret;
};
